import { updateUserDetails } from 'api/auth'
import { createGenesysAgentCallback } from 'api/supportAssistant'
import type { MappedRequestAgentCallbackResult, RequestAgentCallbackResult } from './Modals/RequestAgentCallbackModal'

const SCHEDULED_CALLBACK_TYPES = new Set<App.GenesysAgentCallbackType>([
  'SALES',
  'SUPPORT',
])

type CallbackAuthAccount = Pick<
  App.AuthAccount,
  'memberId' | 'phonePrefix' | 'phone' | 'givenName' | 'surname' | 'email' | 'countryCode'
>

export type CallbackRequester =
  | { type: 'guest' }
  | { type: 'authenticated', account: CallbackAuthAccount }

interface CreateRequestAgentCallbackData {
  formData: RequestAgentCallbackResult
  requester: CallbackRequester
  chatId?: string
}

function mapFormData({ formData, requester, chatId }: CreateRequestAgentCallbackData) {
  const account = requester.type === 'authenticated' ? requester.account : undefined
  const customerPhone = `${formData.phone.prefix || account?.phonePrefix || ''} ${formData.phone.phone || account?.phone || ''}`.trim()

  return {
    chatId,
    customerId: account?.memberId ?? undefined,
    customerPhone,
    type: formData.type,
    isImmediateCallback: !SCHEDULED_CALLBACK_TYPES.has(formData.type),
    customer: {
      firstName: formData.firstName ?? account?.givenName ?? '',
      lastName: formData.lastName ?? account?.surname ?? '',
      email: formData.email ?? account?.email ?? '',
      phone: `${formData.phone.prefix ?? ''} ${formData.phone.phone ?? ''}`,
      message: formData.message,
      destination: formData.destination,
      numberOfTravellers: formData.numberOfTravellers,
      travelDates: formData.travelDates,
      countryCode: account?.countryCode,
      callbackDate: formData.callbackDate,
      callbackTime: formData.callbackTime,
      timezone: formData.timezone,
    },
  }
}
export async function createRequestAgentCallback(
  formData: RequestAgentCallbackResult,
  requester: CallbackRequester,
  chatId?: string,
): Promise<MappedRequestAgentCallbackResult> {
  const mappedRequestAgentCallbackFormData = mapFormData({
    formData,
    requester,
    chatId,
  })

  const results = await createGenesysAgentCallback(mappedRequestAgentCallbackFormData)

  // Update account details only for authenticated users.
  if (results.data.updatePhoneNumber && requester.type === 'authenticated' && requester.account.memberId) {
    updateUserDetails({
      phone: formData.phone.phone,
      phonePrefix: formData.phone.prefix,
    })
  }

  return results.data
}
